import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import * as _ from 'lodash';
import { UntypedFormGroup } from '@angular/forms';
import { startWith, pairwise } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

//Import froala plugins
import 'froala-editor/js/plugins.pkgd.min';

@Component({
  selector: 'mapfre-auditlib-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent implements OnInit {

  @Input()
  label

  @Input()
  docId: string

  @Input()
  form: UntypedFormGroup = null

  @Input()
  placeholder

  @Input()
  icon

  @Input()
  skipHighlighter = false

  @Input()
  froalaOptions: any = {
    key: 'xGE6oB4H3H4B10D6C4fLUQZf1ASFb1EFRNh1Hb1BCCQDUHnA8B6E5B4B1D3C3A1B8B5==',
    language: this.translateService.currentLang,

    events: {
      'image.beforeUpload': function (files, editor) {
        if (files.length) {
          // Create a File Reader.
          var reader = new FileReader();

          // Set the reader to insert images when they are loaded.
          reader.onload = (e: any) => {
            var result = e.target.result;
            this.image.insert(result, null, null, this.image.get());
          };

          // Read image as base64.
          reader.readAsDataURL(files[0]);
        }

        this.popups.hideAll();
        // Stop default upload chain.
        return false
      }
    },
    toolbarButtons: {
      'moreText': {
        'buttons': ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'textColor', 'clearFormatting', '|', 'strikeThrough', 'subscript', 'superscript', 'backgroundColor', 'inlineClass', 'inlineStyle'],
        'buttonsVisible' : 6
      },
      'moreParagraph': {
        'buttons': ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOLSimple', 'formatOL', 'formatUL', '|', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
        'buttonsVisible' : 7
      },
      'moreRich': {
        'buttons': ['fullscreen']
      },
    },
    toolbarButtonsMD: {
      'moreText': {
        'buttons': ['bold', 'italic', 'underline', 'fontFamily', '|', 'fontSize', 'textColor', 'clearFormatting', 'strikeThrough', 'subscript', 'superscript', 'backgroundColor', 'inlineClass', 'inlineStyle'],
        'buttonsVisible' : 4
      },
      'moreParagraph': {
        'buttons': ['alignLeft', 'alignCenter', 'alignRight', '|', 'alignJustify', 'formatOLSimple', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
        'buttonsVisible' : 3
      },
      'moreRich': {
        'buttons': ['fullscreen']
      },
    },
    toolbarButtonsSM: {
      'moreText': {
        'buttons': ['bold', 'italic', '|', 'underline', 'fontFamily',  'fontSize', 'textColor', 'clearFormatting', 'strikeThrough', 'subscript', 'superscript', 'backgroundColor', 'inlineClass', 'inlineStyle'],
        'buttonsVisible' : 2
      },
      'moreParagraph': {
        'buttons': ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOLSimple', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
        'buttonsVisible' : 0
      },
    },
  }

  _model: string = '';
  @Input()
  get model() {
    return this._model
  }
  set model(value) {
    this._model = value ?? '';
    this.modelChange.emit(this._model);
  }

  @Input() froala = true;

  _readonly: boolean = false;
  @Input()
  get readonly() {
    return this._readonly
  }
  set readonly(value) {
    if (value != null) {
      this._readonly = value;

      // Si el editor ya está inicializado, aplicar directamente
      if (this.editor) {
        this._readonly ? this.editor.edit.off() : this.editor.edit.on();
      }

      // Para cuando el editor aún no se ha inicializado
      _.assign(this.froalaOptions.events, {
        'initialized': (editor) => {
          this._readonly ? editor._editor.edit.off() : editor._editor.edit.on();
        }
      });
    }
  }

  @Output()
  modelChange = new EventEmitter();

  focus: boolean = false;

  editor;
  refresh: boolean = false;

  constructor(private translateService: TranslateService) { }

  ngOnInit() {
    if (!this.froala) {
      this.froalaOptions = null;
    }
    if (this.froalaOptions && !this.froalaOptions.docId && this.docId) {
      this.froalaOptions.docId = this.docId
    }

    if (this.form) {
      this.form.valueChanges.pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          //if we're not changing state we manage the data flow
          if (prev !== null && !_.isEqual(prev, next)) {
            this.form.markAsTouched();
          }
        });
    }

    this.translateService.onLangChange.subscribe(language => {
      this.refresh = true;
      let lang = language.lang;
      if(lang.toLowerCase() === 'pt'){
        lang = 'pt_pt';
      }
      this.froalaOptions.language = lang;
      setTimeout(()=>{
        this.refresh = false;
      },150)
    })
  }

  initialize(event:any){
    event.initialize(this.froalaOptions);
    this.editor = event.getEditor();
  }

  /*
  @HostListener('document:click', ['$event']) clickedOutside($event) {
    // here you can hide your menu
    if (this.focus) {
      this.focus = false;
    }
  }

 
 preventDefault(event) {
   if (event.type === 'click') {
     event.stopPropagation();
   }
 }

 setFocus(event) {
   this.focus = true;
   event.stopPropagation();
 }*/

}
